
























































import Vue from "vue";
import { UserService } from "../../services";
export default Vue.extend({
  name: "UserHome",
  data() {
    return {
      modalMessage: "",
      modalHeader: ""
    };
  },
  computed: {
    user: function (): string {
      return this.$store.getters.user;
    }
  },
  methods: {
    goto: function (route: string): void {
      this.$router.push({ name: route }).catch(() => { });
    },
    deleteAccount: async function (): Promise<void> {
      this.modalHeader = "Ta bort konto";
      this.modalMessage =
        "Vill du verkligen ta bort ditt konto? Alla Lemodikryss skapade av kontot kommer försvinna.";
    },
    closeModal: function (): void {
      this.modalHeader = "";
      this.modalMessage = "";
    },
    confirmDelete: async function (choice: boolean): Promise<void> {
      this.closeModal();
      try {
        if (choice) {
          const response = await UserService.deleteUser();
          this.$router.push({ name: "login" }).catch(() => { });
        }
      } catch (error: any) {
        console.log(error);
      }
    }
  }
});
